import { render, staticRenderFns } from "./idcard_login.vue?vue&type=template&id=0a10a0ae&scoped=true&"
import script from "./idcard_login.vue?vue&type=script&lang=js&"
export * from "./idcard_login.vue?vue&type=script&lang=js&"
import style0 from "./idcard_login.vue?vue&type=style&index=0&id=0a10a0ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a10a0ae",
  null
  
)

export default component.exports